import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
export type DateRelativeDefaultValueConfigFragment = {
  __typename: 'DateRelativeDefaultValueConfig'
  operator: Types.ArithmeticOperation
  noOfDays: number
  DateValueEnum: Types.DateValueEnum
}

export type TimeRelativeDefaultValueConfigFragment = {
  __typename: 'TimeRelativeDefaultValueConfig'
  operator: Types.ArithmeticOperation
  noOfSeconds: number
  TimeValueEnum: Types.TimeValueEnum
}

export type GuidedActionConfigFragment = {
  __typename: 'GuidedActionConfig'
  displayName: string
  displayHeader: string
  contentType: Types.GuidedActionContentType
  content: string
  specialConfig: Array<{
    __typename: 'GuidedActionSpecialConfig'
    id: string
    value: string
    configType: Types.GuidedActionSpecialConfigType
  }>
}

export type IntegerFieldFragment = {
  __typename: 'IntegerField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  intDefaultValue?: number | null
  rangeConfig?: {
    __typename: 'IntegerRangeConfig'
    intMinValue?: number | null
    intMaxValue?: number | null
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type FloatFieldFragment = {
  __typename: 'FloatField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  floatDefaultValue?: number | null
  rangeConfig?: {
    __typename: 'FloatRangeConfig'
    floatMinValue?: number | null
    floatMaxValue?: number | null
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type EmailFieldFragment = {
  __typename: 'EmailField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  regexErrorMessage?: string | null
  validationRegex?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type FileUploaderFieldFragment = {
  __typename: 'FileUploaderField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  allowedFormats: Array<string>
  maxFileSizeKb: number
  maxFileCount: number
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValues: Array<string>
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type LongTextFieldFragment = {
  __typename: 'LongTextField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type PlainTextFieldFragment = {
  __typename: 'PlainTextField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  regexErrorMessage?: string | null
  validationRegex?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  isUnique: boolean
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type UrlFieldFragment = {
  __typename: 'URLField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  regexErrorMessage?: string | null
  validationRegex?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type TimeFieldFragment = {
  __typename: 'TimeField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  timeFieldDefaultValue?: string | null
  relativeDefaultValueConfig?: {
    __typename: 'TimeRelativeDefaultValueConfig'
    operator: Types.ArithmeticOperation
    noOfSeconds: number
    TimeValueEnum: Types.TimeValueEnum
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type DateFieldFragment = {
  __typename: 'DateField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  dateFieldDefaultValue?: string | null
  relativeDefaultValueConfig?: {
    __typename: 'DateRelativeDefaultValueConfig'
    operator: Types.ArithmeticOperation
    noOfDays: number
    DateValueEnum: Types.DateValueEnum
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type DateTimeFieldFragment = {
  __typename: 'DateTimeField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  dateTimeDefaultValue?: string | null
  relativeDefaultValueConfig?: {
    __typename: 'DateTimeRelativeDefaultValueConfig'
    dateConfig?: {
      __typename: 'DateRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfDays: number
      DateValueEnum: Types.DateValueEnum
    } | null
    timeConfig?: {
      __typename: 'TimeRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfSeconds: number
      TimeValueEnum: Types.TimeValueEnum
    } | null
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type DropdownFieldFragment = {
  __typename: 'DropdownField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type MultiSelectFieldFragment = {
  __typename: 'MultiSelectField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  multiStringDefaultValue: Array<string>
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type CheckboxGroupFieldFragment = {
  __typename: 'CheckboxGroupField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  multiStringDefaultValue: Array<string>
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type RadioGroupFieldFragment = {
  __typename: 'RadioGroupField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type PhoneNumberFieldFragment = {
  __typename: 'PhoneNumberField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type FieldsSelectorFieldFragment = {
  __typename: 'FieldsSelectorField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isDependent: boolean
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  fieldSelectorFieldDefaultValue?: string | null
  dependentFields: Array<{
    __typename: 'DependentFields'
    option: string
    dependentFieldIds: Array<string>
  }>
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type LookupFieldFragment = {
  __typename: 'LookupField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isDependent: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  lookupType: Types.LookupType
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type FieldNotFoundFragment = {
  __typename: 'FieldNotFound'
  message?: string | null
}

export type FieldIsDeletedFragment = {
  __typename: 'FieldIsDeleted'
  message?: string | null
}

export type Crime_Os_Common_Field_CheckboxGroupField_Fragment = {
  __typename: 'CheckboxGroupField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  multiStringDefaultValue: Array<string>
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_DateField_Fragment = {
  __typename: 'DateField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  dateFieldDefaultValue?: string | null
  relativeDefaultValueConfig?: {
    __typename: 'DateRelativeDefaultValueConfig'
    operator: Types.ArithmeticOperation
    noOfDays: number
    DateValueEnum: Types.DateValueEnum
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_DateTimeField_Fragment = {
  __typename: 'DateTimeField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  dateTimeDefaultValue?: string | null
  relativeDefaultValueConfig?: {
    __typename: 'DateTimeRelativeDefaultValueConfig'
    dateConfig?: {
      __typename: 'DateRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfDays: number
      DateValueEnum: Types.DateValueEnum
    } | null
    timeConfig?: {
      __typename: 'TimeRelativeDefaultValueConfig'
      operator: Types.ArithmeticOperation
      noOfSeconds: number
      TimeValueEnum: Types.TimeValueEnum
    } | null
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_DropdownField_Fragment = {
  __typename: 'DropdownField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_EmailField_Fragment = {
  __typename: 'EmailField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  regexErrorMessage?: string | null
  validationRegex?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_FieldsSelectorField_Fragment = {
  __typename: 'FieldsSelectorField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isDependent: boolean
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  fieldSelectorFieldDefaultValue?: string | null
  dependentFields: Array<{
    __typename: 'DependentFields'
    option: string
    dependentFieldIds: Array<string>
  }>
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_FileUploaderField_Fragment = {
  __typename: 'FileUploaderField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  allowedFormats: Array<string>
  maxFileSizeKb: number
  maxFileCount: number
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValues: Array<string>
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_FloatField_Fragment = {
  __typename: 'FloatField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  floatDefaultValue?: number | null
  rangeConfig?: {
    __typename: 'FloatRangeConfig'
    floatMinValue?: number | null
    floatMaxValue?: number | null
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_IntegerField_Fragment = {
  __typename: 'IntegerField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  intDefaultValue?: number | null
  rangeConfig?: {
    __typename: 'IntegerRangeConfig'
    intMinValue?: number | null
    intMaxValue?: number | null
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_LongTextField_Fragment = {
  __typename: 'LongTextField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_LookupField_Fragment = {
  __typename: 'LookupField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isDependent: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  lookupType: Types.LookupType
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_MultiSelectField_Fragment = {
  __typename: 'MultiSelectField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  multiStringDefaultValue: Array<string>
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_PhoneNumberField_Fragment = {
  __typename: 'PhoneNumberField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_PlainTextField_Fragment = {
  __typename: 'PlainTextField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  regexErrorMessage?: string | null
  validationRegex?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  isUnique: boolean
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_RadioGroupField_Fragment = {
  __typename: 'RadioGroupField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  options: Array<string>
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_TimeField_Fragment = {
  __typename: 'TimeField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  timeFieldDefaultValue?: string | null
  relativeDefaultValueConfig?: {
    __typename: 'TimeRelativeDefaultValueConfig'
    operator: Types.ArithmeticOperation
    noOfSeconds: number
    TimeValueEnum: Types.TimeValueEnum
  } | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_Field_UrlField_Fragment = {
  __typename: 'URLField'
  fieldId: string
  constFieldId: string
  permissionType: Types.PermissionType
  gofId: string
  templateId: string
  name: string
  description?: string | null
  fieldType?: Types.FieldType | null
  isRequired: boolean
  helpText?: string | null
  tooltip?: string | null
  placeholderText?: string | null
  regexErrorMessage?: string | null
  validationRegex?: string | null
  isUnique: boolean
  systemFieldEnum?: Types.SystemFieldEnum | null
  displayConfig?: Types.FieldDisplayConfigEnum | null
  oneTimeEditable: boolean
  fieldsResetOnUpdate: Array<string>
  isAutomationIntegrated?: boolean | null
  stringDefaultValue?: string | null
  guidedActionConfig?: {
    __typename: 'GuidedActionConfig'
    displayName: string
    displayHeader: string
    contentType: Types.GuidedActionContentType
    content: string
    specialConfig: Array<{
      __typename: 'GuidedActionSpecialConfig'
      id: string
      value: string
      configType: Types.GuidedActionSpecialConfigType
    }>
  } | null
}

export type Crime_Os_Common_FieldFragment =
  | Crime_Os_Common_Field_CheckboxGroupField_Fragment
  | Crime_Os_Common_Field_DateField_Fragment
  | Crime_Os_Common_Field_DateTimeField_Fragment
  | Crime_Os_Common_Field_DropdownField_Fragment
  | Crime_Os_Common_Field_EmailField_Fragment
  | Crime_Os_Common_Field_FieldsSelectorField_Fragment
  | Crime_Os_Common_Field_FileUploaderField_Fragment
  | Crime_Os_Common_Field_FloatField_Fragment
  | Crime_Os_Common_Field_IntegerField_Fragment
  | Crime_Os_Common_Field_LongTextField_Fragment
  | Crime_Os_Common_Field_LookupField_Fragment
  | Crime_Os_Common_Field_MultiSelectField_Fragment
  | Crime_Os_Common_Field_PhoneNumberField_Fragment
  | Crime_Os_Common_Field_PlainTextField_Fragment
  | Crime_Os_Common_Field_RadioGroupField_Fragment
  | Crime_Os_Common_Field_TimeField_Fragment
  | Crime_Os_Common_Field_UrlField_Fragment

export const FieldNotFoundFragmentDoc = gql`
  fragment FieldNotFound on FieldNotFound {
    message
  }
`
export const FieldIsDeletedFragmentDoc = gql`
  fragment FieldIsDeleted on FieldIsDeleted {
    message
  }
`
export const GuidedActionConfigFragmentDoc = gql`
  fragment GuidedActionConfig on GuidedActionConfig {
    displayName
    displayHeader
    contentType
    content
    specialConfig {
      id
      value
      configType
    }
  }
`
export const IntegerFieldFragmentDoc = gql`
  fragment IntegerField on IntegerField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    rangeConfig {
      intMinValue: minValue
      intMaxValue: maxValue
    }
    intDefaultValue: defaultValue
    isUnique
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const FloatFieldFragmentDoc = gql`
  fragment FloatField on FloatField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    rangeConfig {
      floatMinValue: minValue
      floatMaxValue: maxValue
    }
    floatDefaultValue: defaultValue
    isUnique
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const EmailFieldFragmentDoc = gql`
  fragment EmailField on EmailField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    regexErrorMessage
    validationRegex
    isUnique
    stringDefaultValue: defaultValue
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const FileUploaderFieldFragmentDoc = gql`
  fragment FileUploaderField on FileUploaderField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    allowedFormats
    stringDefaultValues: defaultValues
    maxFileSizeKb
    maxFileCount
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const LongTextFieldFragmentDoc = gql`
  fragment LongTextField on LongTextField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    stringDefaultValue: defaultValue
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const PlainTextFieldFragmentDoc = gql`
  fragment PlainTextField on PlainTextField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    regexErrorMessage
    validationRegex
    systemFieldEnum
    isUnique
    stringDefaultValue: defaultValue
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const UrlFieldFragmentDoc = gql`
  fragment URLField on URLField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    regexErrorMessage
    validationRegex
    isUnique
    stringDefaultValue: defaultValue
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const TimeRelativeDefaultValueConfigFragmentDoc = gql`
  fragment TimeRelativeDefaultValueConfig on TimeRelativeDefaultValueConfig {
    TimeValueEnum: valueEnum
    operator
    noOfSeconds
  }
`
export const TimeFieldFragmentDoc = gql`
  fragment TimeField on TimeField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    timeFieldDefaultValue: defaultValue
    relativeDefaultValueConfig {
      ...TimeRelativeDefaultValueConfig
    }
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${TimeRelativeDefaultValueConfigFragmentDoc}
  ${GuidedActionConfigFragmentDoc}
`
export const DateRelativeDefaultValueConfigFragmentDoc = gql`
  fragment DateRelativeDefaultValueConfig on DateRelativeDefaultValueConfig {
    DateValueEnum: valueEnum
    operator
    noOfDays
  }
`
export const DateFieldFragmentDoc = gql`
  fragment DateField on DateField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    dateFieldDefaultValue: defaultValue
    relativeDefaultValueConfig {
      ...DateRelativeDefaultValueConfig
    }
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${DateRelativeDefaultValueConfigFragmentDoc}
  ${GuidedActionConfigFragmentDoc}
`
export const DateTimeFieldFragmentDoc = gql`
  fragment DateTimeField on DateTimeField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    relativeDefaultValueConfig {
      dateConfig {
        ...DateRelativeDefaultValueConfig
      }
      timeConfig {
        ...TimeRelativeDefaultValueConfig
      }
    }
    dateTimeDefaultValue: defaultValue
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${DateRelativeDefaultValueConfigFragmentDoc}
  ${TimeRelativeDefaultValueConfigFragmentDoc}
  ${GuidedActionConfigFragmentDoc}
`
export const DropdownFieldFragmentDoc = gql`
  fragment DropdownField on DropdownField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    options
    stringDefaultValue: defaultValue
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const MultiSelectFieldFragmentDoc = gql`
  fragment MultiSelectField on MultiSelectField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    options
    multiStringDefaultValue: defaultValues
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const CheckboxGroupFieldFragmentDoc = gql`
  fragment CheckboxGroupField on CheckboxGroupField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    options
    multiStringDefaultValue: defaultValues
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const RadioGroupFieldFragmentDoc = gql`
  fragment RadioGroupField on RadioGroupField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    options
    stringDefaultValue: defaultValue
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const PhoneNumberFieldFragmentDoc = gql`
  fragment PhoneNumberField on PhoneNumberField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    isUnique
    systemFieldEnum
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const FieldsSelectorFieldFragmentDoc = gql`
  fragment FieldsSelectorField on FieldsSelectorField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    isDependent
    options
    fieldSelectorFieldDefaultValue: defaultValue
    dependentFields {
      option
      dependentFieldIds
    }
    systemFieldEnum
    templateId
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const LookupFieldFragmentDoc = gql`
  fragment LookupField on LookupField {
    fieldId
    constFieldId
    permissionType
    gofId
    templateId
    name
    description
    fieldType
    isRequired
    helpText
    tooltip
    placeholderText
    isDependent
    systemFieldEnum
    lookupType
    displayConfig
    oneTimeEditable
    guidedActionConfig {
      ...GuidedActionConfig
    }
    fieldsResetOnUpdate
    isAutomationIntegrated
  }
  ${GuidedActionConfigFragmentDoc}
`
export const Crime_Os_Common_FieldFragmentDoc = gql`
  fragment Crime_Os_Common_Field on Field {
    ... on IntegerField {
      ...IntegerField
    }
    ... on FloatField {
      ...FloatField
    }
    ... on EmailField {
      ...EmailField
    }
    ... on FileUploaderField {
      ...FileUploaderField
    }
    ... on LongTextField {
      ...LongTextField
    }
    ... on PlainTextField {
      ...PlainTextField
    }
    ... on URLField {
      ...URLField
    }
    ... on TimeField {
      ...TimeField
    }
    ... on DateField {
      ...DateField
    }
    ... on DateTimeField {
      ...DateTimeField
    }
    ... on DropdownField {
      ...DropdownField
    }
    ... on MultiSelectField {
      ...MultiSelectField
    }
    ... on CheckboxGroupField {
      ...CheckboxGroupField
    }
    ... on RadioGroupField {
      ...RadioGroupField
    }
    ... on PhoneNumberField {
      ...PhoneNumberField
    }
    ... on FieldsSelectorField {
      ...FieldsSelectorField
    }
    ... on LookupField {
      ...LookupField
    }
  }
  ${IntegerFieldFragmentDoc}
  ${FloatFieldFragmentDoc}
  ${EmailFieldFragmentDoc}
  ${FileUploaderFieldFragmentDoc}
  ${LongTextFieldFragmentDoc}
  ${PlainTextFieldFragmentDoc}
  ${UrlFieldFragmentDoc}
  ${TimeFieldFragmentDoc}
  ${DateFieldFragmentDoc}
  ${DateTimeFieldFragmentDoc}
  ${DropdownFieldFragmentDoc}
  ${MultiSelectFieldFragmentDoc}
  ${CheckboxGroupFieldFragmentDoc}
  ${RadioGroupFieldFragmentDoc}
  ${PhoneNumberFieldFragmentDoc}
  ${FieldsSelectorFieldFragmentDoc}
  ${LookupFieldFragmentDoc}
`
